import BrokerGuard from "app/guard/brokerGuard";
import {lazy} from "react";
import { Navigate } from "react-router-dom";
const CvppProposal = lazy(() => import("../pages/broker/cvpp/CvppProposal"));
const CvppSearchList = lazy(() => import("../pages/broker/cvpp/CvppSearchList"));
const CvppManagement = lazy(() => import("../pages/broker/cvpp/CvppManagement"));
const CvppContractList =  lazy(() => import("../pages/broker/cvpp/CvppContractList"));
const CvppDetail = lazy(() => import("../pages/broker/cvpp/CvppDetail"));

export const brokerRouter: any = [
  { path: "/brk/cvpp", element: <Navigate to="search" replace /> },
  { path: "/brk/cvpp/search", element: <BrokerGuard><CvppSearchList /></BrokerGuard> },
  // { path: "/brk/cvpp/detail/:mgRsrcId", element: <BrokerGuard><CvppDetail /></BrokerGuard> },
  { path: "/brk/cvpp/detail/:mgRsrcId", element: <CvppDetail /> },
  { path: "/brk/cvpp/contract", element: <BrokerGuard><CvppContractList /></BrokerGuard> },
  { path: "/brk/cvpp/management", element: <BrokerGuard><CvppManagement /></BrokerGuard> },
]